module.exports = __webpack_public_path__ + "img/radio-wai-bidayuh.175d0dda.jpg";